import React from 'react';
// import './win-loader.css';
 
const WinLoader = ({ zIndex = 'z-50' }) => {
  return (
    <div className='twp w-screen h-screen flex justify-center items-center top-0 left-0 fixed z-50'>
    <div className={`bg-zinc-500 bg-opacity-70 transition-all duration-700 w-full h-full flex items-center justify-center`}>
      <svg className="animate-spin" width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.7849 18.7C12.2849 21 9.08492 24.3 6.28492 37.2C3.88492 49.4 -1.71508 69.8 4.88492 72.5C8.68492 74.9 13.9849 73.3 18.1849 72.3C22.5849 71.1 26.2849 70 31.3849 69.1C23.7849 68.6 18.6849 67.5 15.3849 62.8C10.6849 56.8 12.9849 42.2 15.9849 34.3C19.0849 25.9 25.4849 23.3 32.3849 22.5C37.7849 22 42.9849 23 46.7849 24.9C43.3849 20.1 34.6849 17.8 26.8849 17.8C23.9849 17.7 21.0849 18 18.7849 18.7Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M55.4848 1.4C51.0848 2.6 47.3848 3.7 42.2848 4.6C49.8848 5.1 54.9848 6.2 58.2848 10.9C62.9848 16.9 60.6848 31.5 57.6848 39.4C54.5848 47.8 48.1848 50.4 41.2848 51.2C40.3848 51.3 39.4848 51.3 38.5848 51.3C34.1848 51.3 30.0848 50.3 26.8848 48.8C30.3848 53.7 38.9848 56 46.7848 56C49.6848 56 52.4848 55.7 54.8848 55C61.3848 52.7 64.5848 49.4 67.3848 36.5C69.7848 24.3 75.3848 3.9 68.7848 1.2C67.3848 0.3 65.6848 0 63.8848 0C61.0848 0 58.0848 0.8 55.4848 1.4Z"
          fill="url(#paint1_linear)"
        />
        <path
          d="M1.18493 4.90005C-1.11507 8.70005 0.484931 14.0001 1.38493 18.2001C2.58493 22.6 3.68493 26.3 4.58493 31.4C5.08493 23.8 6.18493 18.7 10.8849 15.4C16.8849 10.7 31.4849 13 39.3849 16C47.7849 19.1 50.3849 25.5001 51.1849 32.4001C51.6849 37.8001 50.6849 43 48.7849 46.8C55.3849 42.1 57.2849 27.5 54.9849 18.8C52.7849 12.3 49.3849 9.00005 36.4849 6.30005C28.4849 4.70005 17.0849 1.80005 9.28493 1.80005C5.18493 1.80005 2.18493 2.60005 1.18493 4.90005Z"
          fill="url(#paint2_linear)"
        />
        <path
          d="M18.685 55C20.985 61.5 24.285 64.7 37.185 67.5C49.385 69.9 69.785 75.5 72.485 68.9C74.885 65.1 73.285 59.8 72.285 55.6C71.085 51.2 69.985 47.5 69.085 42.4C68.585 50 67.485 55.1 62.785 58.4C56.785 63.1 42.185 60.8 34.285 57.8C25.885 54.7 23.285 48.3 22.485 41.4C21.985 36 22.985 30.8 24.885 27C18.185 31.7 16.285 46.2 18.685 55Z"
          fill="url(#paint3_linear)"
        />
        <defs>
          <linearGradient id="paint0_linear" x1="1.76862" y1="45.7145" x2="46.7901" y2="45.7145" gradientUnits="userSpaceOnUse">
            <stop stopColor="#40AFC9" />
            <stop offset="0.011236" stopColor="#40AFC9" />
            <stop offset="0.5" stopColor="#0098B8" />
            <stop offset="0.9944" stopColor="#0F7D83" />
            <stop offset="1" stopColor="#0F7D83" />
          </linearGradient>
          <linearGradient id="paint1_linear" x1="26.91" y1="28.0195" x2="71.9346" y2="28.0195" gradientUnits="userSpaceOnUse">
            <stop stopColor="#EF6724" />
            <stop offset="1" stopColor="#F49121" />
          </linearGradient>
          <linearGradient id="paint2_linear" x1="-0.0150688" y1="24.295" x2="56.0208" y2="24.295" gradientUnits="userSpaceOnUse">
            <stop stopColor="#8DC442" />
            <stop offset="1" stopColor="#488867" />
          </linearGradient>
          <linearGradient id="paint3_linear" x1="17.6793" y1="49.4382" x2="73.717" y2="49.4382" gradientUnits="userSpaceOnUse">
            <stop stopColor="#00A995" />
            <stop offset="5e-05" stopColor="#3D3A93" />
            <stop offset="0.5056" stopColor="#A43794" />
            <stop offset="1" stopColor="#D92429" />
          </linearGradient>
        </defs>
      </svg>
      <div className='twp'>
        <span className="absolute text-white inset-0 pt-[30%] w-full h-full flex items-center justify-center xs:px-6 text-center">
          Hold tight while we gather available Fiber Internet speeds in your area.
        </span>
      </div>
    </div>
    </div>
  );
};
 
export default WinLoader;
 